<template>
    <transition name="Toastr__transition">
        <div :class="`Toastr__item Toastr__item--${level}`" v-show="isVisible">
            <slot>{{ text }}</slot>
            <div class="Toastr__item__progressbar" :class="{'w-full': showProgressBar}"></div>
        </div>
    </transition>
</template>

<script>
export default {

    props: {
        level: {
            type: String,
            default: 'info'
        },
        text: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isVisible: false,
            showProgressBar: false
        }
    },

    methods: {

        show() {
            this.isVisible = true;

            // if not delayed, progressbar will start at full width
            let progressTimeout = setTimeout(() => {
                this.showProgressBar = true;
            }, 100);

            this.hide();
        },

        hide() {
            setTimeout(() => {
                this.isVisible = false;
            }, 3000);
        }
    },

    mounted() {
        this.show();
    }
};
</script>
